import { render, staticRenderFns } from "./PostDouble1000Arm2432-F.vue?vue&type=template&id=58d7b30e"
import script from "./PostDouble1000Arm2432-F.vue?vue&type=script&lang=js"
export * from "./PostDouble1000Arm2432-F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports